import { SIMPLE_PROMOTION } from "../components/WorkSpace/CanvasViewer/EncarteConstants";
import ProductStyles from "./ProductStyles";

export default function ProductObj(
  id = 0,
  name = `Nome do produto ${++id}`,
  promotionPrice = "00,00",
  varejoPrice,
  atacadoPrice,
  imageURL = "",
  imageURLTmp = "",
  measurement = "UND",
  styles = ProductStyles(),
  promotionType = SIMPLE_PROMOTION,
  takeX,
  payY,
  normalSellingPrice,
  quantity = 1,
  obs = "",
) {
  return {
    id: id,
    name: name,
    promotionPrice: promotionPrice,
    varejoPrice: varejoPrice,
    atacadoPrice: atacadoPrice,
    imageURL: imageURL,
    measurement: measurement,
    imageURLTmp: imageURLTmp,
    styles: styles,
    promotionType: promotionType,
    takeX: takeX,
    payY: payY,
    normalSellingPrice: normalSellingPrice,
    quantity: quantity,
    obs: obs,
  };
}
